<template>
  <div>
    <div v-loading="edit.loading" class="edit_main">
      <el-form size="mini">
        <el-form-item label="姓名：">
          <el-input
            v-model="edit.params.name"
            class="edit_input"
            autocomplete="off"
            :disabled="true"
            width="50%"
          />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="edit.params.status"
            class="edit_input"
            size="mini"
            placeholder="请选择上级"
            filterable
          >
            <el-option :value="1" label="可用" />
            <el-option :value="0" label="不可用" />
          </el-select>
        </el-form-item>
        <el-form-item label="角色：">
          <el-select
            v-model="edit.params.role"
            :loading="role.loading"
            class="edit_input"
            size="mini"
            placeholder="请选择角色"
            @change="changeSelect"
          >
            <el-option
              v-for="(item, index) in role.response.list"
              :key="index"
              :value="item.name"
              :label="item.name"
            />
            <el-button class="add_role" size="mini" type="primary" @click="showAddRoleBox">新增角色</el-button>
          </el-select>
        </el-form-item>
        <el-form-item label="上级：">
          <el-select
            v-model="edit.params.parent"
            :loading="superior.loading"
            class="edit_input"
            size="mini"
            placeholder="请选择上级"
            filterable
          >
            <el-option
              v-for="(item, index) in superior.response.list"
              :key="index"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span class="footer">
      <el-button size="mini" @click="editCancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="editConfirm">确 定</el-button>
    </span>
  </div>
</template>

<script>
import UserResource from '@/api/user';
const userResource = new UserResource();
import RoleResource from '@/api/role';
const roleResource = new RoleResource();
export default {
  props: {
    // 编辑参数
    data: { type: Object, default: null },
  },
  data() {
    return {
      role: {
        loading: false,
        response: { list: [] },
        params: {},
      },
      superior: {
        loading: false,
        response: { list: [] },
        params: {
          keyword: '',
          roles: [],
          page: 1,
          limit: -1,
        },
      },
      edit: {
        loading: false,
        params: {
          roles: [],
          parent: '',
          id: '',
          status: 0,
          role: '',
        },
      },
      add_role: {
        loading: false,
        params: {
          name: '',
        },
      },
    };
  },
  created() {
    this.getTopList();
    this.getRoleList();
    this.edit.params = this.data;
    this.edit.params.role = this.data.roles[0];
  },
  methods: {
    /** 获取上级列表 */
    async getTopList() {
      const { keyword, role, page, limit } = this.superior.params;
      const params = {
        keyword,
        role,
        page,
        limit,
      };
      this.superior.loading = true;
      const { data } = await userResource.getUserList(params);
      this.superior.response.list = data;
      this.superior.loading = false;
    },

    /** 获取角色列表 */
    async getRoleList() {
      this.role.loading = true;
      const { list } = await roleResource.getRoleList();
      this.role.response.list = list;
      this.role.loading = false;
    },

    /** 确认编辑 */
    editConfirm() {
      const { id, parent, status, role } = this.edit.params;
      const params = {
        role,
        parent,
        status,
      };
      this.edit.loading = true;
      userResource
        .updateUser(params, id)
        .then(response => {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$emit('config');
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.edit.loading = false;
        });
    },

    editCancel() {
      this.$emit('cancel');
    },

    /** 显示新增角色盒子 */
    showAddRoleBox() {
      this.$prompt('请输入角色名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          this.addRole(value);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          });
        });
    },

    /** 新增角色 */
    addRole(name) {
      this.add_role.loading = true;
      roleResource
        .addRole({ name })
        .then(response => {
          const {
            data: { id },
          } = response;
          this.role.response.list.push({ id, name });
          /** 动态更新 */
          this.$forceUpdate();
          this.$message({
            type: 'success',
            message: '新增角色成功',
          });
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.add_role.loading = false;
        });
    },

    // 更新select
    changeSelect() {
      this.$forceUpdate();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-input,
.el-select {
  width: 350px !important;
}
.footer {
  display: block;
  text-align: center;
}
</style>
